import React, { useRef, useState ,useEffect} from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  logoutCredential, selectedDestinationDropdownCredential, selectedpassengerCredential
  , searchCredential, PaymentTypeDropdownCredential, FeeServiceDropdownCredential,
  selectedOriginDropdownCredential, moduleDropdown,
  flightManifestBoardingCredential,
  flightTripBoardingCredential,
  setflightLegKeyCredential,
  assistQueueCredential, flightSearchCredential, redirectToPageCredentials, setPrintMode, FetchPrintModeModalStatus
} from '../ReduxState';
import { checkinModule } from '../Utility/CommonFun';
import { useHistory } from 'react-router-dom';
import { fncLogoutApi } from '../Utility/ApiCall.js';
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, Form } from "react-bootstrap";


export default function Model(props) {
         const logoutOk = useRef(null);
  
  const dispatch = useDispatch()
  let history = useHistory();
  const [modalShow, setmodalShow] = useState(true);
  function fncLogoutCalled() {
       
    fncLogoutApi()
      .then((returnVal) => {
        localStorage.removeItem("LoginToken");
        localStorage.removeItem("SITAPrinters");
        // localStorage.clear();
        dispatch(logoutCredential(
          {
            type: "",
            UserName: "",
            Password: "",
            Role: "",
            Id: 0,
            IsLogin: false
          }));
        dispatch(selectedOriginDropdownCredential(
          {
            type: "",
            OriginDropdown: []
          }))
        dispatch(selectedDestinationDropdownCredential(
          {
            type: "",
            DestinationDropdown: []
          }))
        dispatch(FeeServiceDropdownCredential(
          {
            type: "",
            FeeServiceDropdown: []
          }))
        dispatch(PaymentTypeDropdownCredential(
          {
            type: "",
            PaymentTypeDropdown: []
          }))
        dispatch(searchCredential(
          {
            type: "",
            SearchedRecordData: [],
            SearchedFlightDetails: []
          }));
        dispatch(selectedpassengerCredential(
          {
            type: "",
            SelectedPassengerData: []
          }));
          dispatch(moduleDropdown(
            {
              type:"",
              module: checkinModule
            }
          ));
          dispatch(flightSearchCredential(
            {
                type: "",
                flightList: [],
            }))
            dispatch(flightManifestBoardingCredential(
              {
                  type: '',
                  flightManifestBoarding: null
              }
          ))
          dispatch(flightTripBoardingCredential(
              {
                  type: '',
                  flightTripBoarding: null
              }
          ))
          dispatch(assistQueueCredential(
              {
                  type: "",
                  assistQueue: [],
              }
          ))
          dispatch(setflightLegKeyCredential({
            type: '',
            selectedFlight: null
          }));
          dispatch(FetchPrintModeModalStatus(
            {
              type: "PRINT_MODE_MODAL_STATUS",
              PrintModeModalStatus: false
            }
          ));
          dispatch(setPrintMode(
            {
              type: "",
              selectedMode: "Native"
            }
          ));
        // dispatch(redirectToPageCredentials(
        //   {
        //     type: "",
        //     redirectionPage: '/Search'
        //   }
        // ));
        setmodalShow(false);
        history.push('/');
        window.location.reload();
      })
      .catch(err => console.log("Axios err: ", err))
  }
  // update
 useEffect(() => {
          if (modalShow) {
                  logoutOk.current?.focus();
          }
  }, [modalShow,props.trigger]);
  return (props.trigger) ? (
    <Modal show={modalShow} >
      <Modal.Header>
        <Modal.Title>Message</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Your current session time has expired.
        <strong></strong>
      </Modal.Body>
      <Modal.Footer>
        <input type="submit"  ref={logoutOk} value="OK" className="focusClass btn btn-red px-4 align-lg-self-center text-nowrap w-30 btn-search-booking SerachBtn OrangeShadow" onClick={fncLogoutCalled} />
      </Modal.Footer>
    </Modal>
  ) : "";
}